import { memo } from 'react'
import AudioTracks from './AudioTracks'
import EmptyTrack from './EmptyTrack'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'

const Tracks = (props: { preventOnClick: boolean }) => {
  const hasAudioItems = useSelector(projectDataSelectors.hasAudioItems)

  return hasAudioItems ? <AudioTracks {...props} /> : <EmptyTrack />
}

export default memo(Tracks)
